import { UpdateCategoriesPaginationPayload } from '~/core/state/actions';
import { State } from '../types/state';

const updateCategoriesPagination = (state: State, payload: UpdateCategoriesPaginationPayload): State => {
    const setId = payload.querySetIdentifier;
    let initialPagination = state.initialPagination;

    const set = state.sets.find((set) => set.querySet.identifier === setId);
    const setIsCategories = set?.layoutPosition === 'serp-categories';

    if (setIsCategories) {
        if (!initialPagination) {
            initialPagination = {};
        }
        initialPagination[setId] = { size: payload.size };
    }

    return {
        ...state,
        initialPagination,
    };
};

export default updateCategoriesPagination;
